/* DON'T EDIT THIS FILE: edit original and run build again */ import {
  typeCheckerError,
  typeCheckerOkResult,
} from "../../framework/type-checker/type-checker-errors.ts";
import {
  TypeCheckerErrorType,
  TypeCheckerSchemaType,
  TypeCheckerStatus,
} from "../../framework/type-checker/type-checker-types.ts";
import {
  typeCheckValue,
  validatedTypeChecker,
} from "../../framework/type-checker/type-checker.ts";

export type StylingConfig = {
  theme: "dark" | "light" | "old";
};

const stylingConfigDefault: StylingConfig = { theme: "old" };

const expected = validatedTypeChecker<StylingConfig>({
  type: TypeCheckerSchemaType.object,
  schema: {
    theme: {
      type: TypeCheckerSchemaType.primitive,
      schema: "string",
      validator: (value, path) => {
        if (
          !(typeof value === "string") ||
          !["dark", "light", "old"].includes(value)
        ) {
          return typeCheckerOkResult(stylingConfigDefault.theme, [
            typeCheckerError(TypeCheckerErrorType.caughtError, value, path),
          ]);
        }
        return typeCheckerOkResult(value as StylingConfig["theme"]);
      },
    },
  },
});

export const getStylingConfig = (): StylingConfig => {
  const data = localStorage.getItem("stylingConfig");
  if (data) {
    try {
      const parsed = JSON.parse(data);
      const validated = typeCheckValue(parsed, expected);
      if (validated.errors?.length) {
        console.error("caughtStylingTypeErrors: " + validated.errors);
      }
      if (validated.status === TypeCheckerStatus.ok) {
        return validated.value;
      }
      return stylingConfigDefault;
    } catch (e) {
      console.error(e);
      return stylingConfigDefault;
    }
  }
  return stylingConfigDefault;
};

export const saveStylingConfig = (props: StylingConfig): void => {
  localStorage.setItem("stylingConfig", JSON.stringify(props));
};

export const setTheme = (theme?: StylingConfig["theme"]): void => {
  if (!theme) {
    theme = getStylingConfig()?.theme ?? "old";
  }
  document.body.setAttribute("data-theme", theme);
};
